'use client';

import { Button } from '@coolblue-development/freddy';
import { Sliders } from '@coolblue-development/icons';
import { useFilterDrawer } from '@features/filter/context';
import { useTranslation } from '@i18n/useTranslation';

import FilterIndicator from './FilterIndicator';

export default function MobileFiltersTrigger({ fab = false }: { fab?: boolean }) {
  const { t } = useTranslation('webshop.filterPage.drawer');
  const { hasAppliedFilters, setIsOpen } = useFilterDrawer();

  return (
    <Button
      endIcon={hasAppliedFilters && <FilterIndicator />}
      size={fab ? 'medium' : 'small'}
      variant={fab ? 'primary' : 'secondary'}
      startIcon={<Sliders />}
      onClick={() => setIsOpen(true)}
      sx={getButtonStyles(fab)}
    >
      {t('filters')}
    </Button>
  );
}

function getButtonStyles(fab: boolean) {
  return fab
    ? ({
        position: 'fixed',
        minWidth: '50%',
        left: '25%',
        bottom: '2rem',
        zIndex: 99
      } as const)
    : {};
}
